<div class="dropdown" *ngIf="hasAccess">
    <button class="btn btn-primary dropdown-toggle btn-sm" type="button" id="genericDetailImportDropdown"
        data-bs-toggle="dropdown" aria-expanded="false" [disabled]="disabled">
        <i class="bi bi-box-arrow-down"></i> Import
    </button>

    <ul class="dropdown-menu" aria-labelledby="genericDetailImportDropdown" style="min-width: 220px;">
        <li class="px-2 py-1" *ngIf="isLoadingSourceTypes">
            <span class="text-muted small">Loading...</span>
        </li>

        <li class="px-2 py-1" *ngIf="!isLoadingSourceTypes && sourceTypeOptions.length === 0">
            <span class="text-muted small">No import sources configured</span>
        </li>

        <li class="px-2 py-1" *ngIf="!isLoadingSourceTypes">
            <div class="d-grid gap-2">
                <!-- Tenant-specific source-document types — one shared Value List
             ('GenericImportSourceType', via sourceTypeVlCode) reused on every
             screen that hosts this button, instead of a list per screen.
                     Selecting one loads this tenant's GenericFormUIC field config for that
                     source type (Step 3). Steps 4/5/6 will replace the checkpoint modal
                     below with the real candidate-line uic-form grid. -->
                <button class="btn btn-primary btn-sm w-100 text-center" type="button"
                    *ngFor="let item of sourceTypeOptions" (click)="onSourceTypeSelected(item)">
                    {{ item.vliName }}
                </button>
            </div>
        </li>
    </ul>
</div>

<!-- Step 3/4 checkpoint modal. Step 5 will replace the plain preview table below with
     the real editable uic-form grid (with row selection + live calc, Steps 5/6). -->
<ng-template #sourceTypeConfigModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">
            Import from {{ selectedSourceType?.vliName }}
        </h5>
        <button type="button" class="btn-close" (click)="closeConfigModal()" aria-label="Close"></button>
    </div>
    <div class="modal-body">

        <!-- Step 4: document picker — only wired up for source types with a real
             *_ReadByXIdForImport endpoint (currently just Quotation, via
             crm.QuotationDetail_ReadByQuotationIdForImport). -->
        <div class="mb-3" *ngIf="isDocumentPickerSupported">
            <label class="form-label">Select {{ selectedSourceType?.vliName }} No<span class="text-danger">*</span></label>
            <ng-select [items]="documentSearchResults" bindValue="id" bindLabel="label"
                appendTo="body" [loading]="isSearchingDocuments" (search)="searchDocuments($event.term)"
                [(ngModel)]="selectedDocumentId" (change)="onDocumentSelected($event?.id ?? null)">
            </ng-select>
        </div>

        <div class="alert alert-warning py-2 small" *ngIf="selectedSourceType && !isDocumentPickerSupported">
            A document picker + line fetch hasn't been built yet for "{{ selectedSourceType.vliName }}" — only the
            field config below is verifiable so far.
        </div>

        <div *ngIf="isLoadingFormConfig" class="text-muted">Loading field config...</div>

        <div *ngIf="!isLoadingFormConfig && formConfigError" class="text-danger">
            {{ formConfigError }}
        </div>

        <!-- Step 5: real candidate lines for the chosen document, rendered as an
             editable, row-selectable grid via the shared uic-form component
             (enableMultipleForms). Re-created each time candidateLines is
             repopulated so onImportFormReady can seed it fresh via
             patchWithDependencies. Live qty/price calc lands in Step 6;
             actual submission to the target document lands in Step 7. -->
        <ng-container *ngIf="isDocumentPickerSupported && selectedDocumentId">
            <div *ngIf="isLoadingCandidateLines" class="text-muted">Loading lines...</div>

            <div *ngIf="!isLoadingCandidateLines && candidateLinesError" class="text-danger small">
                {{ candidateLinesError }}
            </div>

            <ng-container
                *ngIf="!isLoadingCandidateLines && !isLoadingFormConfig && candidateLines.length > 0 && selectedFormUIC.length > 0">
                <!-- Compact list view: one header row (built from the same field config,
                     re-using the identical card/card-body/row markup so Bootstrap's grid
                     gutters line up pixel-for-pixel with the data rows below) followed by
                     the real uic-form grid with its per-row labels hidden via CSS
                     (see .generic-import-grid rules in the stylesheet). -->
                <div class="generic-import-grid">
                    <div class="card p-0 generic-import-header-card">
                        <div class="card-body p-1">
                            <div class="row">
                                <div *ngFor="let f of selectedFormUIC" [class]="f.wrapperClass">
                                    <span *ngIf="f.uiInputType?.toLowerCase() !== 'checkbox'">{{ f.uiLabel }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <app-uic-form #importUicFormRef [gFormUIC]="selectedFormUIC" [enableMultipleForms]="true"
                        [isFormModal]="false" [openForm]="true" [showModalHeader]="false"
                        [showAddMultiFormButton]="false" [showRemoveMultiFormButton]="false"
                        (formReady)="onImportFormReady($event, importUicFormRef)">
                    </app-uic-form>
                </div>
            </ng-container>
        </ng-container>
    </div>
    <div class="modal-footer d-flex justify-content-between align-items-center">
        <div class="text-muted small">{{ importSelectionMessage }}</div>
        <div class="d-flex gap-2">
            <button type="button" class="btn btn-sm btn-primary"
                [disabled]="!isImportGridReady || !hasAnySelectedRow || isSubmittingImport"
                (click)="onImportSelectedClick()">
                {{ isSubmittingImport ? 'Importing...' : 'Import Selected' }}
            </button>
            <button type="button" class="btn btn-sm btn-secondary" [disabled]="isSubmittingImport"
                (click)="closeConfigModal()">Close</button>
        </div>
    </div>
</ng-template>

